
import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QAResponseQuestionEntity from "../../../../domain/entities/qa_response_question.entity";
import QAResponseQuestionDto from "../../../dto/qa_response_question.dto";

const updateResponseApiImpl = async (response: QAResponseQuestionEntity, jobId: string): Promise<Either<ErrorEntity, QAResponseQuestionEntity>> => {
    try {
        let relativeUrl: string = `/job/${jobId}`;
        const body = QAResponseQuestionDto.toJSON(response);
        await di.get<HostApi>(HostApiName).put(relativeUrl, body, { contentType: 'application/json' });
        return right(response)
    } catch (e) {
        return left({});
    }
}

export default updateResponseApiImpl;
